export default __webpack_public_path__ + "static/media/Priest's Straps of the Underworld.8938d2da.jpg";